module.exports = __webpack_public_path__ + "static/media/ethernet.834404c3.svg";